// Shared sort/quick-filter option lists for the client-side "Filtres" dialog
// (src/components/filters/filtersDialog.jsx + filterChipGroup.jsx). Same
// shape/convention as the other filter lists in this folder (product.model,
// user.model, option.model): { _id, label, labelKey }.

export const NameSortList = [
  { _id: "name_asc", label: "Nom (A → Z)", labelKey: "filters.sortNameAsc" },
  { _id: "name_desc", label: "Nom (Z → A)", labelKey: "filters.sortNameDesc" },
];

export const PriceSortList = [
  { _id: "price_asc", label: "Prix croissant", labelKey: "filters.sortPriceAsc" },
  { _id: "price_desc", label: "Prix décroissant", labelKey: "filters.sortPriceDesc" },
];

// Products/Ingredients "Tri" section: name + price sort options together.
export const NamePriceSortList = [...NameSortList, ...PriceSortList];

export const DateSortList = [
  { _id: "date_desc", label: "Plus récentes", labelKey: "filters.sortDateRecent" },
  { _id: "date_asc", label: "Plus anciennes", labelKey: "filters.sortDateOld" },
];

export const TotalSortList = [
  { _id: "total_asc", label: "Total croissant", labelKey: "filters.sortTotalAsc" },
  { _id: "total_desc", label: "Total décroissant", labelKey: "filters.sortTotalDesc" },
];

// Commandes "Tri" section: date + total sort options together.
export const HistorySortList = [...DateSortList, ...TotalSortList];

export const DiscountFilterList = [
  { _id: "all", label: "Tous", labelKey: "filters.allDiscounts" },
  { _id: "with", label: "Avec remise", labelKey: "filters.withDiscount" },
  { _id: "without", label: "Sans remise", labelKey: "filters.withoutDiscount" },
];

export const ValueSortList = [
  { _id: "value_asc", label: "Valeur croissante", labelKey: "filters.sortValueAsc" },
  { _id: "value_desc", label: "Valeur décroissante", labelKey: "filters.sortValueDesc" },
];

export const UsageSortList = [
  { _id: "usage_asc", label: "Utilisation croissante", labelKey: "filters.sortUsageAsc" },
  { _id: "usage_desc", label: "Utilisation décroissante", labelKey: "filters.sortUsageDesc" },
];

// Coupons "Tri" section: value (couponValue) + usage count + creation date
// (backed by `startDate`, see coupon screen) sort options together.
export const CouponSortList = [...ValueSortList, ...UsageSortList, ...DateSortList];

// Generic comparator helper: sorts a copy of `items` according to a sort id
// coming from the lists above. `getName`/`getPrice`/`getDate`/`getTotal`/
// `getUsage` let each screen say where those fields live on its own model.
export const applySort = (
  items,
  sortValue,
  { getName, getPrice, getDate, getTotal, getUsage } = {}
) => {
  if (!sortValue || !Array.isArray(items) || items.length === 0) return items;
  const sorted = [...items];
  switch (sortValue) {
    case "name_asc":
      sorted.sort((a, b) =>
        String(getName ? getName(a) : a?.name ?? "").localeCompare(
          String(getName ? getName(b) : b?.name ?? ""),
          undefined,
          { sensitivity: "base" }
        )
      );
      break;
    case "name_desc":
      sorted.sort((a, b) =>
        String(getName ? getName(b) : b?.name ?? "").localeCompare(
          String(getName ? getName(a) : a?.name ?? ""),
          undefined,
          { sensitivity: "base" }
        )
      );
      break;
    case "price_asc":
      sorted.sort(
        (a, b) =>
          Number(getPrice ? getPrice(a) : a?.price ?? 0) -
          Number(getPrice ? getPrice(b) : b?.price ?? 0)
      );
      break;
    case "price_desc":
      sorted.sort(
        (a, b) =>
          Number(getPrice ? getPrice(b) : b?.price ?? 0) -
          Number(getPrice ? getPrice(a) : a?.price ?? 0)
      );
      break;
    case "date_asc":
      sorted.sort(
        (a, b) =>
          new Date(getDate ? getDate(a) : a?.boughtAt).getTime() -
          new Date(getDate ? getDate(b) : b?.boughtAt).getTime()
      );
      break;
    case "date_desc":
      sorted.sort(
        (a, b) =>
          new Date(getDate ? getDate(b) : b?.boughtAt).getTime() -
          new Date(getDate ? getDate(a) : a?.boughtAt).getTime()
      );
      break;
    case "total_asc":
      sorted.sort(
        (a, b) =>
          Number(getTotal ? getTotal(a) : a?.total ?? 0) -
          Number(getTotal ? getTotal(b) : b?.total ?? 0)
      );
      break;
    case "total_desc":
      sorted.sort(
        (a, b) =>
          Number(getTotal ? getTotal(b) : b?.total ?? 0) -
          Number(getTotal ? getTotal(a) : a?.total ?? 0)
      );
      break;
    case "value_asc":
      sorted.sort(
        (a, b) =>
          Number(getPrice ? getPrice(a) : a?.price ?? 0) -
          Number(getPrice ? getPrice(b) : b?.price ?? 0)
      );
      break;
    case "value_desc":
      sorted.sort(
        (a, b) =>
          Number(getPrice ? getPrice(b) : b?.price ?? 0) -
          Number(getPrice ? getPrice(a) : a?.price ?? 0)
      );
      break;
    case "usage_asc":
      sorted.sort(
        (a, b) =>
          Number(getUsage ? getUsage(a) : a?.usageCount ?? 0) -
          Number(getUsage ? getUsage(b) : b?.usageCount ?? 0)
      );
      break;
    case "usage_desc":
      sorted.sort(
        (a, b) =>
          Number(getUsage ? getUsage(b) : b?.usageCount ?? 0) -
          Number(getUsage ? getUsage(a) : a?.usageCount ?? 0)
      );
      break;
    default:
      break;
  }
  return sorted;
};
